import { render, staticRenderFns } from "./Appointment.vue?vue&type=template&id=545402da&scoped=true"
import script from "./Appointment.vue?vue&type=script&lang=js"
export * from "./Appointment.vue?vue&type=script&lang=js"
import style0 from "./Appointment.vue?vue&type=style&index=0&id=545402da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545402da",
  null
  
)

export default component.exports